import { color } from "@smoothincorg/smooth-ui"
import React, { ChangeEvent, FocusEvent } from "react"
import { ReactNode } from "react"
import styled from "styled-components"

type Props = {
  id: string
  name: string
  value: string | number
  checked: boolean
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  required?: boolean
  onBlur: (e: FocusEvent) => void
  className?: string
  children?: ReactNode
}

const Component: React.VFC<Props> = (props) => {
  return (
    <label
      className={`${props.className} ${props.checked && `${props.className}--is_checked`}`}
      htmlFor={props.id}
    >
      <input
        type="radio"
        name={props.name}
        id={props.id}
        checked={props.checked}
        className={`${props.className}__input`}
        onChange={props.onChange}
        onBlur={props.onBlur}
        value={props.value}
      />
      <h3 className={`${props.className}__title`}>{props.children}</h3>
    </label>
  )
}

const StyledComponent = styled(Component)`
  height: 48px;
  border: 2px solid #e2e7ec;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &__title {
    font-size: 1.5rem;
    font-weight: bold;
  }

  &--is_checked {
    border: 2px solid ${color.main};
    color: ${color.main};
    background-color: #eaf7fa;
  }

  &__input {
    position: absolute;
    width: 14px;
    height: 14px;
    border: 2px solid;
    border-color: #e2e7ec;
    border-radius: 25px;
    left: 8px;
    outline: none;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;

    &:checked {
      border-color: ${color.main};
      &::after {
        content: '';
        width: 7px;
        height: 7px;
        background-color: ${color.main};
        position: absolute;
        border-radius: 25px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
`

export const Radio = StyledComponent
